// Mock data for Maison Eze properties
export const mockProperties = [
  {
    id: 1,
    title: 'Belle Époque Residence',
    location: 'Paris, France',
    type: 'Penthouse',
    bedrooms: 5,
    description: 'Exquisite penthouse overlooking the Eiffel Tower with original period features and modern luxury amenities.',
    image: 'https://images.pexels.com/photos/2227832/pexels-photo-2227832.jpeg'
  },
  {
    id: 2,
    title: 'Riad Jardin Secret',
    location: 'Marrakesh, Morocco',
    type: 'Traditional Riad',
    bedrooms: 6,
    description: 'Stunning restored riad in the heart of the Medina, featuring traditional Moroccan architecture with contemporary refinement.',
    image: 'https://images.unsplash.com/photo-1624804821465-5c7c80f99bd1?q=80&w=2000'
  },
  {
    id: 3,
    title: 'Green Hill Residence',
    location: 'Belgrade, Serbia',
    type: 'Luxury Apartment',
    bedrooms: 4,
    description: 'Exclusive residence in Belgrade\'s prestigious Green Hill development, featuring modern architecture and premium amenities.',
    image: 'https://customer-assets.emergentagent.com/job_elite-properties-18/artifacts/bpo16lc2_projekat_lokali_izdavanje_YADerlkeWP-Green-Hill-0.jpg'
  },
  {
    id: 4,
    title: 'Serenity Living Penthouse',
    location: 'Vouliagmeni, Greece',
    type: 'Luxury Penthouse',
    bedrooms: 4,
    description: 'Spectacular penthouse maisonette in the heart of Athens Riviera with breathtaking sea views and 2A energy certification.',
    image: 'https://static.wixstatic.com/media/55275b_52485b0618f84a848b4dfc3214075dac~mv2.jpg/v1/fill/w_1919,h_753,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/55275b_52485b0618f84a848b4dfc3214075dac~mv2.jpg'
  },
  {
    id: 5,
    title: 'Haussmann Masterpiece',
    location: 'Paris, France',
    type: 'Historic Apartment',
    bedrooms: 4,
    description: 'Meticulously renovated Haussmann apartment featuring high ceilings, marble fireplaces, and herringbone parquet.',
    image: 'https://images.pexels.com/photos/2227838/pexels-photo-2227838.jpeg'
  },
  {
    id: 6,
    title: 'Palmeraie Sanctuary',
    location: 'Marrakesh, Morocco',
    type: 'Luxury Villa',
    bedrooms: 5,
    description: 'Contemporary villa in the exclusive Palmeraie district, surrounded by olive groves with Atlas Mountain views.',
    image: 'https://images.unsplash.com/photo-1624804823268-7d5454caa8c8?q=80&w=2000'
  }
];